import type { ReactNode } from "react";
import { BackLink } from "./BackLink";

interface Props {
  title: string;
  back?: { to: string; label: string };
  action?: ReactNode;
  sub?: ReactNode;
}

/** The prototype's page head (`.ph`): an optional back link, one title, at most one line under it. */
export function PageHeader({ title, back, action, sub }: Props) {
  return (
    <header className="ph">
      {back && (
        <div className="ctx">
          <BackLink to={back.to} label={back.label} />
        </div>
      )}
      {action ? (
        <div className="ph-t">
          <h1>{title}</h1>
          {action}
        </div>
      ) : (
        <h1>{title}</h1>
      )}
      {sub && <p className="ph-s">{sub}</p>}
    </header>
  );
}
